export default __webpack_public_path__ + "static/media/capaPaesItalianos.2c98003d.jpg";